import { GENERIC } from "./modules";
/* MbuziPlus Course map: 8 parts, 42 modules, 172 notional hours (ten hours = one credit).
   Modules 4 and 5 are open today; the rest are being built in the agreed order. */
export const LOGO = "/certificate/mbuziplus-logo.jpg";
export const PARTS = [
 {
  "no": 1,
  "name": "Begin the journey",
  "about": "Know the programme, the business, the people and the goat"
 },
 {
  "no": 2,
  "name": "Build your farm",
  "about": "Plan, house and equip, then buy safely"
 },
 {
  "no": 3,
  "name": "Feed and keep healthy",
  "about": "Nutrition, health, welfare and climate"
 },
 {
  "no": 4,
  "name": "Breed and multiply",
  "about": "Reproduction, genetics, kidding and how milk is made"
 },
 {
  "no": 5,
  "name": "Manage with data",
  "about": "Records, routines and risk"
 },
 {
  "no": 6,
  "name": "Add value",
  "about": "Milk quality, health value, products, transport, markets, compliance and exports"
 },
 {
  "no": 7,
  "name": "Fund and grow",
  "about": "Money, return, insurance, loans, groups and succession"
 },
 {
  "no": 8,
  "name": "Practise and graduate",
  "about": "Farm visits, capstone, examination, certificate"
 }
];
const RAW_MODULES = [
 {
  "no": 1,
  "part": 1,
  "title": "MbuziPlus: the programme and the dairy goat value chain",
  "hours": 4,
  "mbuziplus": "All eight MbuziPlus elements, the six steps, training sessions T1 to T3, the Academy and the Package",
  "id": "mbuziplus-programme",
  "live": true
 },
 {
  "no": 2,
  "part": 1,
  "title": "Goat economics: how dairy goats make money",
  "hours": 4,
  "mbuziplus": "Package economics; standing milk buyer; manure sold on the farmer's behalf",
  "id": null,
  "live": false
 },
 {
  "no": 3,
  "part": 1,
  "title": "Youth, women and families in dairy goat farming",
  "hours": 3,
  "mbuziplus": "MbuziPlus is built especially for women and youth on very little land",
  "id": null,
  "live": false
 },
 {
  "no": 4,
  "part": 1,
  "title": "Breeds and choosing your goat",
  "hours": 4,
  "mbuziplus": "Genetics: verified breed with known productivity; why a crossbred often earns more",
  "id": "breed-selection",
  "live": true
 },
 {
  "no": 5,
  "part": 1,
  "title": "Anatomy, body condition and physiology",
  "hours": 4,
  "mbuziplus": "Veterinary care: body condition scoring taught in T1",
  "id": "goat-anatomy",
  "live": true
 },
 {
  "no": 6,
  "part": 2,
  "title": "Planning the farm: site, land, climate and law",
  "hours": 4,
  "mbuziplus": "Small-land model; fodder plots as in Muthigi",
  "id": null,
  "live": false
 },
 {
  "no": 7,
  "part": 2,
  "title": "Housing and construction",
  "hours": 5,
  "mbuziplus": "Goat houses built by the Muthigi group; seen on a T3 farm visit",
  "id": null,
  "live": false
 },
 {
  "no": 8,
  "part": 2,
  "title": "Equipment, tools and farm technology",
  "hours": 4,
  "mbuziplus": "Ear tags; milk chilling freezer used by the Muthigi group",
  "id": null,
  "live": false
 },
 {
  "no": 9,
  "part": 2,
  "title": "Buying foundation stock safely",
  "hours": 3,
  "mbuziplus": "Genetics: partnered breeder supplies a tagged, recorded goat from day one",
  "id": null,
  "live": false
 },
 {
  "no": 10,
  "part": 3,
  "title": "Nutrition fundamentals",
  "hours": 5,
  "mbuziplus": "Feed access: feed concentrate is part of the Package",
  "id": null,
  "live": false
 },
 {
  "no": 11,
  "part": 3,
  "title": "Forage, feed planning and rations",
  "hours": 5,
  "mbuziplus": "Feed access; rations on a Kenyan budget (T1)",
  "id": null,
  "live": false
 },
 {
  "no": 12,
  "part": 3,
  "title": "Herd health and disease prevention",
  "hours": 5,
  "mbuziplus": "Veterinary care: health logged, problems caught early",
  "id": null,
  "live": false
 },
 {
  "no": 13,
  "part": 3,
  "title": "Common diseases, parasites and treatment",
  "hours": 6,
  "mbuziplus": "T2 deep dive with a veterinarian",
  "id": null,
  "live": false
 },
 {
  "no": 14,
  "part": 3,
  "title": "Welfare, behaviour and handling",
  "hours": 3,
  "mbuziplus": "Daily care standards taught in T1",
  "id": null,
  "live": false
 },
 {
  "no": 15,
  "part": 3,
  "title": "Climate and goat productivity",
  "hours": 3,
  "mbuziplus": "Climate-smart farming impact; cover for the goat",
  "id": null,
  "live": false
 },
 {
  "no": 16,
  "part": 4,
  "title": "Reproduction and breeding management",
  "hours": 5,
  "mbuziplus": "Breeding adds income",
  "id": null,
  "live": false
 },
 {
  "no": 17,
  "part": 4,
  "title": "Genetics and selection",
  "hours": 4,
  "mbuziplus": "Genetics: known productivity profiles",
  "id": null,
  "live": false
 },
 {
  "no": 18,
  "part": 4,
  "title": "Artificial insemination and semen",
  "hours": 4,
  "mbuziplus": "Breeding services and improved genetics",
  "id": null,
  "live": false
 },
 {
  "no": 19,
  "part": 4,
  "title": "Pregnancy, kidding and kid rearing",
  "hours": 5,
  "mbuziplus": "Veterinary care at kidding; kids as income",
  "id": null,
  "live": false
 },
 {
  "no": 20,
  "part": 4,
  "title": "Goat hormones and how milk is made, from processing to release",
  "hours": 4,
  "mbuziplus": "Milk yield drivers (T1); explains why feed and health protect income",
  "id": null,
  "live": false
 },
 {
  "no": 21,
  "part": 4,
  "title": "Lactation, milking and milk quality",
  "hours": 5,
  "mbuziplus": "Milking seen on a T3 farm visit; milk goes to a standing buyer",
  "id": null,
  "live": false
 },
 {
  "no": 22,
  "part": 5,
  "title": "Identification, animal records and data management",
  "hours": 4,
  "mbuziplus": "One record: every goat tracked from registration",
  "id": null,
  "live": false
 },
 {
  "no": 23,
  "part": 5,
  "title": "Farm management, labour and routines",
  "hours": 4,
  "mbuziplus": "Cost per litre and first-year income plan (T1)",
  "id": null,
  "live": false
 },
 {
  "no": 24,
  "part": 5,
  "title": "Risk, biosecurity and emergency planning",
  "hours": 3,
  "mbuziplus": "Cover for the goat and the farmer; veterinary support",
  "id": null,
  "live": false
 },
 {
  "no": 25,
  "part": 6,
  "title": "Milk testing and milk quality",
  "hours": 4,
  "mbuziplus": "Buyer quality standards, for example the premium offtaker",
  "id": null,
  "live": false
 },
 {
  "no": 26,
  "part": 6,
  "title": "Human digestion of milk, composition and health value",
  "hours": 4,
  "mbuziplus": "Child nutrition impact of MbuziPlus",
  "id": null,
  "live": false
 },
 {
  "no": 27,
  "part": 6,
  "title": "Processing milk: pasteurised, yoghurt, ghee, cheese",
  "hours": 6,
  "mbuziplus": "Value addition beyond raw milk",
  "id": null,
  "live": false
 },
 {
  "no": 28,
  "part": 6,
  "title": "Soaps, creams, manure and other products",
  "hours": 4,
  "mbuziplus": "Manure sold on the farmer's behalf",
  "id": null,
  "live": false
 },
 {
  "no": 29,
  "part": 6,
  "title": "Transport, logistics and the cold chain",
  "hours": 3,
  "mbuziplus": "A milk chilling freezer helps the Muthigi group keep milk fresh and reach larger buyers",
  "id": null,
  "live": false
 },
 {
  "no": 30,
  "part": 6,
  "title": "Markets, branding and selling",
  "hours": 4,
  "mbuziplus": "Market access: standing buyer and partners",
  "id": null,
  "live": false
 },
 {
  "no": 31,
  "part": 6,
  "title": "Digital marketing and selling online",
  "hours": 3,
  "mbuziplus": "Market access through partners and the Imfuyo Market Place",
  "id": null,
  "live": false
 },
 {
  "no": 32,
  "part": 6,
  "title": "Compliance: licences, standards and food safety",
  "hours": 3,
  "mbuziplus": "Imfuyo's registration with the Office of the Data Protection Commissioner shows the standard",
  "id": null,
  "live": false
 },
 {
  "no": 33,
  "part": 6,
  "title": "Exporting dairy goat products",
  "hours": 3,
  "mbuziplus": "Market access: from a standing buyer to wider markets, within the rules",
  "id": null,
  "live": false
 },
 {
  "no": 34,
  "part": 7,
  "title": "Financial literacy and budgeting",
  "hours": 4,
  "mbuziplus": "Financing: finance arranged with partners",
  "id": null,
  "live": false
 },
 {
  "no": 35,
  "part": 7,
  "title": "Return on investment and business plan",
  "hours": 4,
  "mbuziplus": "First-year income plan (T1)",
  "id": null,
  "live": false
 },
 {
  "no": 36,
  "part": 7,
  "title": "Livestock insurance",
  "hours": 3,
  "mbuziplus": "Cover protects the animal and the farmer",
  "id": null,
  "live": false
 },
 {
  "no": 37,
  "part": 7,
  "title": "Loans and animals as collateral",
  "hours": 4,
  "mbuziplus": "Goat as security with partner lenders under Kenya's Movable Property Security Rights Act",
  "id": null,
  "live": false
 },
 {
  "no": 38,
  "part": 7,
  "title": "Groups, cooperatives and the value chain",
  "hours": 3,
  "mbuziplus": "Farmer groups such as Muthigi; Dairy Goats Association of Kenya",
  "id": null,
  "live": false
 },
 {
  "no": 39,
  "part": 7,
  "title": "Farm succession and growing the enterprise",
  "hours": 2,
  "mbuziplus": "Growing from the two-goat start of the Package",
  "id": null,
  "live": false
 },
 {
  "no": 40,
  "part": 8,
  "title": "Practicals: farm visits and expert sessions",
  "hours": 10,
  "mbuziplus": "T3 farm visits; expert sessions",
  "id": null,
  "live": false
 },
 {
  "no": 41,
  "part": 8,
  "title": "Capstone: your farm plan",
  "hours": 5,
  "mbuziplus": "Your first-year plan with MbuziPlus",
  "id": null,
  "live": false
 },
 {
  "no": 42,
  "part": 8,
  "title": "Final examination and certificate",
  "hours": 3,
  "mbuziplus": "Certificate of Completion from Imfuyo Academy",
  "id": null,
  "live": false
 }
];
export const MODULES = RAW_MODULES.map((m) => {
  const g = Object.values(GENERIC).find((x) => x.no === m.no);
  return g ? { ...m, id: g.id, live: true } : m;
});
export const TOTAL_HOURS = MODULES.reduce((n, m) => n + m.hours, 0);

/* "In this module" summaries. Written by an assistant from the module's own lessons, then saved.
   A summary only: the module is completed by reading the lessons and passing the quiz. */
export const SUMMARIES = {
  ...Object.fromEntries(Object.values(GENERIC).map((g) => [g.id, { outcomes: g.outcomes, summary: g.summary, sources: g.sources }])),
  "breed-selection": {
    outcomes: [
      "Compare the main dairy goat breeds in Kenya for milk, size and care needs",
      "Read the milk timeline and a lactation curve, and know what to check when milk drops",
      "Time heat, breeding and kidding, and plan your first does on a calendar",
      "Use a buyer's checklist to choose a healthy doe and keep her apart for 30 days",
    ],
    summary: "This module helps you choose the right goat before you spend money. You meet the main dairy breeds, learn why MbuziPlus recommends the German Alpine, and follow the milk timeline from kidding to the rest period. You learn when to breed, how long pregnancy lasts, how to read a lactation curve and what a crossbred is. It ends with a buyer's checklist, a worked example, a video, a ten-question quiz and a short plan you write for your own farm.",
    sources: [
      { label: "Kenya Agricultural and Livestock Research Organization, Dairy Goat Breeds and Breeding", url: "https://navcdp.kalro.org/docs/kcsap/DAIRY%20GOAT%20BREEDS%20AND%20BREEDING.pdf" },
      { label: "Washington State University Extension, Dairy Goat Production", url: "https://wpcdn.web.wsu.edu/wp-extension/uploads/sites/2056/2023/05/Dairy-Goat-Production.pdf" },
    ],
  },
  "goat-anatomy": {
    outcomes: [
      "Name the four stomach compartments and read the left flank for bloat or poor feeding",
      "Describe a good udder and list ways to prevent mastitis",
      "Do the FAMACHA eye check and body condition score, and know what each result means",
      "Recognise warning signs of CCPP, CLA and CAE and know when to call a veterinary officer",
    ],
    summary: "This module teaches you to read your goat's body. You learn the four stomach compartments, the parts of a good udder, the legs and hooves, and what the coat, eyes and nose show you. You learn the FAMACHA eye check for worms, body condition scoring, and the warning signs of three diseases: CCPP, CLA and CAE. It ends with a daily, weekly and monthly check plan, a worked example, a video, a ten-question quiz and a plan you write for your own herd.",
    sources: [
      { label: "Cornell University, New York 4-H Animal Science, Digestive System of Goats", url: "https://cals.cornell.edu/nys-4-h-animal-science-programs/livestock/goats/goat-fact-sheets/digestive-system-of-goats" },
      { label: "University of Rhode Island Sheep and Goat Program, FAMACHA Scoring", url: "https://web.uri.edu/sheepngoat/wp-content/uploads/sites/2281/FAMACHA-Scoring_Final2.pdf" },
      { label: "eXtension Goat Community of Practice, Goat Body Condition Score How-To", url: "https://goats.extension.org/goat-body-condition-score-howto/" },
      { label: "eXtension Goat Community of Practice, Caseous Lymphadenitis", url: "https://goats.extension.org/?p=393" },
      { label: "British Columbia Ministry of Agriculture, Caprine Arthritis Encephalitis", url: "https://www2.gov.bc.ca/assets/gov/farming-natural-resources-and-industry/agriculture-and-seafood/animal-and-crops/animal-disease/cae_updated_20240209.pdf" },
      { label: "Kenya Agricultural and Livestock Research Organization, How to Identify and Control CCPP", url: "https://kalro.org/navcdp/docs/How%20to%20Identify%20and%20Control%20CCPP.pdf" },
      { label: "Washington State University Extension, Dairy Goat Production", url: "https://wpcdn.web.wsu.edu/wp-extension/uploads/sites/2056/2023/05/Dairy-Goat-Production.pdf" },
    ],
  },
};
